import React from "react";
import {SvgIcon, SvgIconProps} from "@material-ui/core"


const EditIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <svg version="1.1" id="Layer_1" x="0px" y="0px"
                 viewBox="0 0 1500 1500">
                <g>
                    <g>
                        <defs>
                            <rect id="SVGID_1_" y="2.369" width="1500" height="1496.26"/>
                        </defs>
                        <path fill="fill:#3D4A78" d="M1384.433,940.92c-20.63,0-37.347,16.717-37.347,37.365v331.687
			c-0.071,61.866-50.207,112.017-112.074,112.073H186.786c-61.867-0.056-112.002-50.207-112.074-112.073V336.469
			c0.071-61.867,50.207-111.999,112.074-112.074h331.702c20.633,0,37.35-16.728,37.35-37.362c0-20.618-16.717-37.362-37.35-37.362
			H186.786C83.682,149.788,0.116,233.354,0,336.469v973.519c0.116,103.119,83.682,186.67,186.786,186.786h1048.227
			c103.118-0.116,186.666-83.667,186.786-186.786V978.286C1421.798,957.637,1405.081,940.92,1384.433,940.92L1384.433,940.92z
			 M1384.433,940.92"/>
                        <path fill="fill:#3D4A78" d="M1406.996,53.556c-65.652-65.652-172.085-65.652-237.737,0
			l-666.494,666.49c-4.556,4.56-7.859,10.231-9.584,16.44l-87.643,316.422c-3.61,12.972,0.06,26.854,9.572,36.396
			c9.527,9.512,23.42,13.167,36.397,9.587l316.406-87.658c6.224-1.724,11.88-5.028,16.455-9.599l666.475-666.494
			c65.551-65.697,65.551-172.055,0-237.752L1406.996,53.556z M584.169,744.319l545.461-545.48l175.915,175.915l-545.48,545.491
			L584.169,744.319z M549.026,814.834L689.566,955.4l-194.398,53.862L549.026,814.834z M1398.008,282.319l-39.61,39.613
			l-175.945-175.93l39.643-39.625c36.471-36.456,95.592-36.456,132.063,0l43.848,43.833
			C1434.423,186.727,1434.423,245.818,1398.008,282.319L1398.008,282.319z M1398.008,282.319"/>
                    </g>
                </g>
            </svg>
        </SvgIcon>
    )
};

export default EditIcon;